var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirBalanced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63001 477.42H847.15V599.11L774.87 550.93L669.85 596.03L563.6 550.93L471.55 636.8L372.09 665.22L328.23 628.77L293.64 576.26L260.9 607.76L188.01 546.6L137.35 554.01L80.52 505.21L7.01001 486.68L7.63001 477.42Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M702.77 489.94H651.71V626.37H702.77V489.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M652.1 471.51H702.49L702.38 490.47L652.04 500.19L652.1 471.52V471.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M660.51 498.6V517.16L694.2 509.9V491.99L660.51 498.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M670.89 514.98V565.98L677.28 556.1L683.23 560.36V512.37L670.89 514.99V514.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M652.03 626.44L663.05 626.86V688.51L671.52 692.11L672.37 690.63L682.54 691.05L683.6 691.9L690.38 688.93L691.02 687.66L691.63 626.62H702.42V769.68H652.09L652.04 626.44H652.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M651.89 626.82H660.54L660.62 688.95L677.21 693.33L694.21 687.56V626.78H702.45V769.8H651.97L651.89 626.81V626.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M651.94 500.18V769.8H702.45V490.4",
    fill: "#131F2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M651.94 500.18V769.8H702.45V490.4",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M660.57 517.05V736.55V517.05Z",
    fill: "#131F2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M660.57 517.05V736.55",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M694.14 509.9V736.28V509.9Z",
    fill: "#131F2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M694.14 509.9V736.28",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M671.27 736.44V727.81H662.97V583.93H660.55",
    fill: "#131F2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M671.27 736.44V727.81H662.97V583.93H660.55",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M694.14 583.98H691.59V727.83H683.31V736.18",
    fill: "#131F2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M694.14 583.98H691.59V727.83H683.31V736.18",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M677.43 573.23L682.11 577.91V626.75H683.68V639.03H670.84V626.67H672.49V579.82L677.43 573.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M671.44 641.05L664.1 647.57V688.92L671.1 691.92",
    fill: "#131F2E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M671.44 641.05L664.1 647.57V688.92L671.1 691.92",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M683.28 641.05L690.62 647.57V688.92L683.62 691.92",
    fill: "#131F2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M683.28 641.05L690.62 647.57V688.92L683.62 691.92",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M671.48 671.39L664.07 673.82L671.48 671.39Z",
    fill: "#131F2E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M671.48 671.39L664.07 673.82",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M683.24 671.39L690.65 673.82L683.24 671.39Z",
    fill: "#131F2E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M683.24 671.39L690.65 673.82",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M663.02 715.84H671.52H663.02Z",
    fill: "#131F2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M663.02 715.84H671.52",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M682.9 715.84H691.4H682.9Z",
    fill: "#131F2E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M682.9 715.84H691.4",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M683.28 721.31C683.28 724.6 680.61 727.26 677.33 727.26C674.05 727.26 671.38 724.59 671.38 721.31C671.38 718.03 674.05 715.36 677.33 715.36C680.62 715.36 683.28 718.03 683.28 721.31Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M683.32 686.74C683.32 690.03 680.65 692.69 677.36 692.69C674.07 692.69 671.41 690.02 671.41 686.74C671.41 683.46 674.08 680.79 677.36 680.79C680.65 680.79 683.32 683.45 683.32 686.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M651.97 735.88L604.03 741.27L651.97 744.86V735.87V735.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M651.97 755.05L604.03 760.44L651.97 764.04V755.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M702.6 755.05L750.54 760.44L702.6 764.04V755.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M702.6 735.88L750.54 741.27L702.6 744.86V735.87V735.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M652.12 471.32H649.57V474.02H652.12V471.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M671.3 471.32H668.75V474.02H671.3V471.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M685.98 471.32H683.43V474.02H685.98V471.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M705.6 471.32H703.05V474.02H705.6V471.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M705.75 459.04H703.2V461.74H705.75V459.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M686.13 459.04H683.58V461.74H686.13V459.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M671.3 458.89H668.75V461.59H671.3V458.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M652.27 459.19H649.72V461.89H652.27V459.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M660.51 461.44V446.01H694.07V461.74L660.51 461.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M648.44 461.58L648.55 471.3H705.99V461.58H648.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M648.39 466.49L706.1 466.6L648.39 466.49Z",
    fill: "#131F2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M648.39 466.49L706.1 466.6",
    stroke: "#F7F9F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M722.62 429.33V425.78H726.91V429.33H722.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M695.19 428.19H704.83L706.21 430.63H718.92V429.36H730.78L731.26 431.42H744.66L740.9 438.84H731.37L730.04 440.32H719.5L718.49 439.05H705.78V442.44H695.29L695.18 428.19H695.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M658.18 446.11L695.26 446.16V424.44H658.26L658.18 446.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M667.06 424.36H664.51V427.06H667.06V424.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M662.93 415.88H660.38V418.58H662.93V415.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M695.33 415.73H692.79V418.43H695.33V415.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M689.99 424.2H687.44V426.9H689.99V424.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M656.89 418.18V424.69H697.72V418.18H656.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M657 421.31H697.68H657Z",
    fill: "#131F2E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M657 421.31H697.68",
    stroke: "#F7F9F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M706.15 430.52C706.15 430.52 704.88 434.49 705.94 439.15L706.15 430.52Z",
    fill: "#131F2E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M706.15 430.52C706.15 430.52 704.88 434.49 705.94 439.15",
    stroke: "#F7F9F9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M718.81 430.57C718.81 430.57 717.96 433.85 718.81 439.2V430.57Z",
    fill: "#131F2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M718.81 430.57C718.81 430.57 717.96 433.85 718.81 439.2",
    stroke: "#F7F9F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M731.31 431.58C731.31 431.58 730.46 434.86 731.36 438.73L731.31 431.58Z",
    fill: "#131F2E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M731.31 431.58C731.31 431.58 730.46 434.86 731.36 438.73",
    stroke: "#F7F9F9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M730.3 420.83C730.3 423.9 727.82 426.4 724.75 426.4C721.68 426.4 719.18 423.92 719.18 420.85V420.83C719.18 417.76 721.66 415.26 724.73 415.26C727.8 415.26 730.3 417.74 730.3 420.81C730.3 420.81 730.3 420.82 730.3 420.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M719.98 423.35L721.41 422.74L719.98 423.35Z",
    fill: "#131F2E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M719.98 423.35L721.41 422.74",
    stroke: "#F7F9F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M719.29 421.34L720.75 421.26L719.29 421.34Z",
    fill: "#131F2E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M719.29 421.34L720.75 421.26",
    stroke: "#F7F9F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M719.58 419.03L720.88 419.48L719.58 419.03Z",
    fill: "#131F2E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M719.58 419.03L720.88 419.48",
    stroke: "#F7F9F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M720.8 416.99L721.78 417.94L720.8 416.99Z",
    fill: "#131F2E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M720.8 416.99L721.78 417.94",
    stroke: "#F7F9F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M724.7 421.8L721.09 417.55L722.22 416.63L725.62 420.93L724.69 421.8H724.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M722.54 415.7L723.1 416.97L722.54 415.7Z",
    fill: "#131F2E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M722.54 415.7L723.1 416.97",
    stroke: "#F7F9F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M725.69 420.88C725.69 421.36 725.31 421.76 724.82 421.76C724.34 421.76 723.94 421.37 723.94 420.89C723.94 420.39 724.32 420 724.81 420C725.29 420 725.69 420.38 725.69 420.87V420.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M724.8 415.3L724.77 416.68L724.8 415.3Z",
    fill: "#131F2E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M724.8 415.3L724.77 416.68",
    stroke: "#F7F9F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M729.63 423.35L728.2 422.74L729.63 423.35Z",
    fill: "#131F2E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M729.63 423.35L728.2 422.74",
    stroke: "#F7F9F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M730.32 421.34L728.86 421.26L730.32 421.34Z",
    fill: "#131F2E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M730.32 421.34L728.86 421.26",
    stroke: "#F7F9F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M730.03 419.03L728.73 419.48L730.03 419.03Z",
    fill: "#131F2E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M730.03 419.03L728.73 419.48",
    stroke: "#F7F9F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M728.81 416.99L727.83 417.94L728.81 416.99Z",
    fill: "#131F2E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M728.81 416.99L727.83 417.94",
    stroke: "#F7F9F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M727.06 415.7L726.5 416.97L727.06 415.7Z",
    fill: "#131F2E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M727.06 415.7L726.5 416.97",
    stroke: "#F7F9F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M730.3 420.83C730.3 423.9 727.82 426.4 724.75 426.4C721.68 426.4 719.18 423.92 719.18 420.85V420.83C719.18 417.76 721.66 415.26 724.73 415.26C727.8 415.26 730.3 417.74 730.3 420.81C730.3 420.81 730.3 420.82 730.3 420.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M669.81 417.65V397.65H666.33V393.76H686.11V397.77H682.33V417.66H669.82L669.81 417.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M676.36 393.76V206.19V393.76Z",
    fill: "#131F2E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M676.36 393.76V206.19",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M350.95 460.27L362.39 460.06L479.12 421.08L485.49 382.95C482.85 378.21 478.23 373.07 470.93 373.48L304.13 398.63C296.27 400.34 290.22 403.6 289.94 411.77L290.58 459.22H292.27V464.3L349.26 464.09L350.95 460.28V460.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M473.64 447.12V402.33C474.09 388.7 485.77 378.06 493.41 377.76L494.95 375.33L510.38 375.25L510.94 376.71L530.19 376.67L530.75 375.28L547.08 375.24L554.38 381.64C561.27 382.2 568.72 392.61 567.11 399.47L574.9 408.31L574.45 437.82L570.4 440.22L570.55 447.56L473.63 447.11L473.64 447.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M587.33 179.17L587.29 185.88L594.95 185.77L594.87 179.2L587.32 179.18L587.33 179.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M624.86 142.4L438.61 142.09L438.92 178.85L633.2 178.7L624.86 142.41V142.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M558.76 142.4V178.54H556.29V142.36L558.76 142.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M521.31 142.29V178.81H518.95L519.07 142.25L521.31 142.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M661.97 272.08C684.4 215.29 676.8 151.16 658.57 104.98L643.74 95.3999L624.9 136.17L624.59 140.8L653.93 265.58C656.56 270.64 661.96 272.07 661.96 272.07L661.97 272.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M526.95 178.72L526.91 177.7H527.74C527.74 177.53 527.76 175.87 527.76 175.87H531.93V177.65H532.7V178.73H526.95V178.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M545.05 178.67L545.01 177.65H545.84C545.84 177.48 545.86 175.82 545.86 175.82H550.03V177.6H550.8V178.68H545.05V178.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M588.15 178.72L588.11 177.7H588.94C588.94 177.53 588.96 175.87 588.96 175.87H593.13V177.65H593.9V178.73H588.15V178.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M608.91 178.65L608.87 177.63H609.7C609.7 177.46 609.72 175.8 609.72 175.8H613.89V177.58H614.66V178.66H608.91V178.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M437.23 183.68H419.85V189.9H437.23V183.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M438.52 183.54V186.61L437.1 186.99V191.99L435.35 193L434.14 191.79V186.93L432.88 186.59V183.65L438.52 183.53V183.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M418.5 183.54V186.61L419.92 186.99V191.99L421.67 193L422.88 191.79V186.93L424.14 186.59V183.65L418.5 183.53V183.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M436.7 183.71H434.77V184.73H436.7V183.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M418.67 142.03H438.52V180.4H418.52L418.67 142.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M418.52 180.33V183.57H438.52V180.33H418.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M422.24 183.71H420.31V184.76H422.24V183.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M435.8 199.83H421.32V204.81H435.8V199.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M418.81 204.22V201.59H420.08L420.06 198.73L421.97 196.76L425.98 199.07V204.21H418.81V204.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M420.78 451.62L420.67 206.24L435.85 206.35L436.62 451.51L420.78 451.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M438.45 204.15V201.52H437.18L437.2 198.66L435.29 196.69L431.28 199V204.14H438.45V204.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M435.31 193.69C435.31 197.44 432.27 200.49 428.52 200.49C424.77 200.49 421.73 197.45 421.73 193.69C421.73 189.93 424.77 186.9 428.52 186.9C432.27 186.9 435.31 189.94 435.31 193.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M423.77 202.9H420.97V204.18H423.77V202.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M436.29 202.88H433.49V204.11H436.29V202.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M432.92 193.61C432.92 196 430.99 197.94 428.6 197.94C426.21 197.94 424.27 196.01 424.27 193.62C424.27 191.22 426.2 189.28 428.59 189.28C430.98 189.28 432.92 191.21 432.92 193.6V193.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M430.3 193.61C430.3 194.59 429.5 195.39 428.52 195.39C427.54 195.39 426.75 194.6 426.75 193.61C426.75 192.62 427.54 191.83 428.52 191.83C429.5 191.83 430.3 192.63 430.3 193.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M418.77 204.26L418.79 206.2H438.47V204.21L418.77 204.27V204.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.99
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M420.31 206.42L420.28 207.17H420.85C420.85 207.3 420.86 208.52 420.86 208.52H423.74V207.21H424.27V206.41H420.3L420.31 206.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M433.05 206.15L433.02 206.9H433.59C433.59 207.03 433.6 208.25 433.6 208.25H436.48V206.94H437.01V206.14H433.04L433.05 206.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M433.01 203.96L432.98 203.21H433.55C433.55 203.08 433.56 201.86 433.56 201.86H436.44V203.17H436.97V203.97H433L433.01 203.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M420.35 203.96L420.32 203.21H420.89C420.89 203.08 420.9 201.86 420.9 201.86H423.78V203.17H424.31V203.97H420.34L420.35 203.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M419.38 183.83L419.36 184.58H419.93C419.93 184.71 419.94 185.93 419.94 185.93H422.82V184.62H423.35V183.82H419.38V183.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M433.75 183.79L433.72 184.54H434.29C434.29 184.67 434.3 185.89 434.3 185.89H437.18V184.58H437.71V183.78H433.74L433.75 183.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M431.39 450.86L431.37 450.11H431.94C431.94 449.98 431.95 448.76 431.95 448.76H434.83V450.07H435.36V450.87H431.39V450.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M422.13 450.93L422.1 450.18H422.67C422.67 450.05 422.68 448.83 422.68 448.83H425.56V450.14H426.09V450.94H422.12L422.13 450.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M546.03 372.72H531.36V375.53H546.03V372.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M510.12 372.89H495.45V375.7H510.12V372.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M534.61 378.81H543C543.66 378.81 544.2 379.35 544.2 380.01V397.09C544.2 397.75 543.66 398.29 543 398.29H534.61C533.95 398.29 533.41 397.75 533.41 397.09V380.01C533.41 379.35 533.95 378.81 534.61 378.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M508.5 447.29L526.93 410.44L547.75 407.89L570.82 448.19L508.5 447.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M564.08 403.99H548.5V407.88H564.08V403.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M501.2 408.39L500.9 411.16C501.72 415.05 504.79 416.78 507.57 416.33L540.9 416.22C554.98 411.69 551.16 398.13 543.52 395.36L520.45 389.14C520.45 389.14 506.44 386.22 504.35 394.01L501.2 408.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M511.76 409.66C511.76 411.85 509.98 413.63 507.79 413.63C505.6 413.63 503.82 411.85 503.82 409.66C503.82 407.47 505.59 405.69 507.79 405.69C509.98 405.69 511.76 407.47 511.76 409.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M518.07 401.52C518.07 402.59 517.2 403.47 516.12 403.47C515.04 403.47 514.17 402.6 514.17 401.52C514.17 400.44 515.04 399.57 516.12 399.57C517.2 399.57 518.07 400.44 518.07 401.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M520.78 395.43C520.78 397.6 519.02 399.35 516.86 399.35C514.7 399.35 512.94 397.59 512.94 395.43C512.94 393.27 514.7 391.51 516.86 391.51C519.02 391.51 520.78 393.27 520.78 395.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M455.98 452.04L461.07 440.6L461.39 413.69",
    fill: "#131F2E"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M455.98 452.04L461.07 440.6L461.39 413.69",
    stroke: "#F7F9F9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M463.37 405.91H459.24V413.54H463.37V405.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M466.44 389.97L466.39 395.58L468.03 397.17L468.08 399.92L471.31 395.26L469.19 395.1L469.24 388.69L466.43 389.96L466.44 389.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M468.82 411C468.61 411 465.91 414.28 465.91 414.28L468.82 411Z",
    fill: "#131F2E"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M468.82 411C468.61 411 465.91 414.28 465.91 414.28",
    stroke: "#F7F9F9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M468.61 399.18H464.64V410.14H468.61V399.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M499.7 406.37C499.7 415.47 492.32 422.85 483.22 422.85C474.12 422.85 466.74 415.47 466.74 406.37C466.74 397.27 474.12 389.89 483.22 389.89C492.32 389.89 499.7 397.27 499.7 406.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M464.22 395.48H458.71V398.29H464.22V395.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M497.76 406.52C497.76 414.46 491.32 420.9 483.38 420.9C475.44 420.9 469 414.46 469 406.52C469 398.58 475.44 392.14 483.38 392.14C491.32 392.14 497.76 398.58 497.76 406.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M515.67 399.05C515.67 405.87 510.14 411.41 503.31 411.41C496.48 411.41 490.95 405.88 490.95 399.05C490.95 392.22 496.48 386.69 503.31 386.69C510.14 386.69 515.67 392.22 515.67 399.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M490.66 401.82L487.21 401.67C487.21 401.67 486.72 401.48 486.76 400.92L486.72 397.89C487.13 397.4 488.07 397.33 488.07 397.33L488.18 389.99L489.08 388.83L491.4 388.94L491.17 397.59V400.59C491.17 400.59 491.25 401.49 490.65 401.83L490.66 401.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M470.04 446.22H574.6C575.26 446.22 575.8 446.76 575.8 447.42V449.97C575.8 450.63 575.26 451.17 574.6 451.17H470.04C469.38 451.17 468.84 450.63 468.84 449.97V447.42C468.84 446.76 469.38 446.22 470.04 446.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M568.46 415.06V435.28H574.53V423.6L568.46 415.06Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M489.16 397.96L489.01 400.84L489.16 397.96Z",
    fill: "#131F2E"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M489.16 397.96L489.01 400.84",
    stroke: "#F7F9F9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M465.12 398.23H459.13V410.68H465.12V398.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M436.3 210.42L436.46 227.49L592.36 450.57L603.94 450.8L436.3 210.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M436.44 213.59L437.19 213.56V214.13C437.32 214.13 438.54 214.14 438.54 214.14V217.02H437.23V217.55H436.43V213.58L436.44 213.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M436.37 222.16L437.12 222.13V222.7C437.25 222.7 438.47 222.71 438.47 222.71V225.59H437.16V226.12H436.36V222.15L436.37 222.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M531.53 182.85L548.9 182.77V179.37H531.53V182.84V182.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M547.75 182.35H530.4V189.32H547.75V182.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.22,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M533.79 178.88H525.99V183.13H533.79V178.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M551.95 178.92H544.15V183.17H551.95V178.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M526.59 183.31V184.24H527.44L527.52 185.24H532.38V184.31L533.23 184.23V183.3H526.59V183.31Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M544.79 183.35V184.28H545.64L545.72 185.28H550.58V184.35L551.43 184.27V183.34H544.79V183.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M525.34 200.81L530.32 196.36L534.77 199.96L532.76 212.67L525.77 203.45L525.35 200.8L525.34 200.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M523.33 225.06L531.17 227.39L531.81 215.1L526.2 211.82L523.34 225.06H523.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M521.32 224.75L525.66 225.91L529.79 202.29L525.13 201.02L521.32 224.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M529.79 202.29L527.67 213.94L529.36 223.16L531.9 209.81L529.78 202.29H529.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M548.4 205.1L545.34 199.17L539.9 200.95L537.25 213.54L547.07 207.42L548.41 205.1H548.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M541.63 228.48L533.48 227.86L537.27 216.15L543.69 215.08L541.64 228.47L541.63 228.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M543.62 228.9L539.15 228.44L543.71 204.9L548.52 205.37L543.62 228.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M543.72 204.9L541.54 216.54L536.67 224.55L539.06 211.17L543.72 204.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M547.83 193.9C547.07 198.79 542.5 202.14 537.61 201.38C532.72 200.62 529.37 196.05 530.13 191.16C530.89 186.27 535.46 182.92 540.35 183.68C545.24 184.44 548.59 189.01 547.83 193.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M539.56 205.8L533.77 205.13L533.91 201.84L532.98 195.82L543.45 197.28L540.29 202.75L539.56 205.79V205.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M541.781 187.427L541.578 188.953L543.838 189.253L544.041 187.726L541.781 187.427Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.24,
    strokeLinecap: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M535.242 186.61L535.039 188.136L537.299 188.437L537.502 186.91L535.242 186.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.24,
    strokeLinecap: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M533.994 187.998L533.475 191.904L544.29 193.341L544.809 189.435L533.994 187.998Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.24,
    strokeLinecap: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M533.832 195.833L533.629 197.359L535.89 197.659L536.092 196.133L533.832 195.833Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.24,
    strokeLinecap: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M540.481 196.69L540.278 198.217L542.538 198.517L542.741 196.991L540.481 196.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.24,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M533.448 191.828L532.929 195.733L543.744 197.171L544.263 193.265L533.448 191.828Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.24,
    strokeLinecap: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M607.51 178.94L607.55 185.81L615.42 185.85L615.31 178.98L607.52 178.95L607.51 178.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M588.39 185.85V188.71H591.14L591.88 185.85H588.38H588.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M614.08 185.93V188.68H611.33L610.83 185.98L614.09 185.93H614.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M591.3 185.9L585.1 211.59L589.02 209.05L590.93 199.09L601.21 208.62L610.85 198.98L613.92 210.42L617.42 212.43L611.33 185.87L608.31 185.82L607.04 195.38L604.97 195.43H597.18L595.43 195.46L594.34 185.9H591.29H591.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M605.29 193.16C605.29 195.47 603.46 197.33 601.21 197.33C598.96 197.33 597.13 195.46 597.13 193.16C597.13 190.85 598.96 188.99 601.21 188.99C603.46 188.99 605.29 190.86 605.29 193.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.33,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M594.32 185.95L592.01 196.28L600.99 204.17L609.65 196.07L608.19 186.06L606.71 195.41L595.38 195.49L594.32 185.96V185.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M596.07 195.49L595.59 199.49L600.99 205.21L606.02 199.65L605.81 195.33L602.02 195.46L601.89 200.54L600.14 200.51V195.48H596.06L596.07 195.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M602.14 370.44H593.31V450.58H602.14V370.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M421.77 450.89H632.32C632.98 450.89 633.52 451.43 633.52 452.09V475.98C633.52 476.64 632.98 477.18 632.32 477.18H421.77C421.11 477.18 420.57 476.64 420.57 475.98V452.09C420.57 451.43 421.11 450.89 421.77 450.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M420.64 461.37L423.11 477.32L434.72 477.39L437.72 450.8L421.73 450.89L421.02 451.12L420.61 451.78L420.59 453.76L420.65 461.36L420.64 461.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M487.94 450.81L488.02 477.36L487.94 450.81Z",
    fill: "#131F2E"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M487.94 450.81L488.02 477.36",
    stroke: "#F7F9F9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M514.38 450.81V477.51V450.81Z",
    fill: "#131F2E"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M514.38 450.81V477.51",
    stroke: "#F7F9F9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M529.89 450.89L530.04 477.63L529.89 450.89Z",
    fill: "#131F2E"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M529.89 450.89L530.04 477.63",
    stroke: "#F7F9F9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M547.08 450.92V477.81V450.92Z",
    fill: "#131F2E"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M547.08 450.92V477.81",
    stroke: "#F7F9F9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M564.08 450.81L564.16 477.66L564.08 450.81Z",
    fill: "#131F2E"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M564.08 450.81L564.16 477.66",
    stroke: "#F7F9F9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M590.11 450.85L590.26 477.78L590.11 450.85Z",
    fill: "#131F2E"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M590.11 450.85L590.26 477.78",
    stroke: "#F7F9F9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M602.99 450.62V477.7V450.62Z",
    fill: "#131F2E"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M602.99 450.62V477.7",
    stroke: "#F7F9F9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M487.55 399.31L490.51 399.42L487.55 399.31Z",
    fill: "#131F2E"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M487.55 399.31L490.51 399.42",
    stroke: "#F7F9F9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M532.65 204.83L539.75 205.89L510.09 379.72L502.89 378.66L532.66 204.83H532.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M620.11 218.24C620.11 225.36 611.32 231.12 600.48 231.12C589.64 231.12 580.86 225.35 580.86 218.24C580.86 211.13 589.65 205.36 600.48 205.36C611.32 205.36 620.11 211.13 620.11 218.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M580.99 217.24L620.2 217.99L617.57 357.76L578.36 357.01L580.99 217.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.26,
    strokeLinecap: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M587.38 369.69H583.41V372.61H587.38V369.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M612.43 370.03H608.46V372.95H612.43V370.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M582.57 364.83L613.39 365.12L613.32 370.66L582.51 370.37L582.57 364.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M578.38 356.6L578.22 364.31L581.98 367.21L613.75 367.34L617.41 364.23L617.62 356.98L578.38 356.61V356.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.27
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M599.14 221.69H601.39C601.56 221.69 601.69 221.82 601.69 221.99V231.58C601.69 231.75 601.56 231.88 601.39 231.88H599.14C598.98 231.88 598.84 231.75 598.84 231.58V221.99C598.84 221.82 598.97 221.69 599.14 221.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M492.36 463.99H508.2C508.86 463.99 509.4 464.53 509.4 465.19V471.37C509.4 472.03 508.86 472.57 508.2 472.57H492.36C491.7 472.57 491.16 472.03 491.16 471.37V465.19C491.16 464.53 491.7 463.99 492.36 463.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M493.71 465.04H505.47C506.13 465.04 506.67 465.58 506.67 466.24V469.61C506.67 470.27 506.13 470.81 505.47 470.81H493.71C493.05 470.81 492.51 470.27 492.51 469.61V466.24C492.51 465.58 493.05 465.04 493.71 465.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M569.04 463.38H584.88C585.54 463.38 586.08 463.92 586.08 464.58V470.76C586.08 471.42 585.54 471.96 584.88 471.96H569.04C568.38 471.96 567.84 471.42 567.84 470.76V464.58C567.84 463.92 568.38 463.38 569.04 463.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M570.39 464.42H582.15C582.81 464.42 583.35 464.96 583.35 465.62V468.99C583.35 469.65 582.81 470.19 582.15 470.19H570.39C569.73 470.19 569.19 469.65 569.19 468.99V465.62C569.19 464.96 569.73 464.42 570.39 464.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M509.05 451.16L509.08 451.91H508.51C508.51 452.04 508.5 453.26 508.5 453.26H505.62V451.95H505.09V451.15H509.06L509.05 451.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M524.86 451.23L524.89 451.98H524.32C524.32 452.11 524.31 453.33 524.31 453.33H521.44V452.02H520.91V451.22H524.88L524.86 451.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M541.82 451.2L541.85 451.95H541.28C541.28 452.08 541.27 453.3 541.27 453.3H538.39V451.99H537.86V451.19H541.83L541.82 451.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M558.45 451.12L558.48 451.87H557.91C557.91 452 557.9 453.22 557.9 453.22H555.02V451.91H554.49V451.11H558.46L558.45 451.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M596.89 451.15L596.91 451.76H596.47C596.47 451.86 596.46 452.86 596.46 452.86H594.25V451.8H593.84V451.16H596.89V451.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.56
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M601.7 451.17L601.72 451.78H601.28C601.28 451.88 601.27 452.88 601.27 452.88H599.06V451.82H598.65V451.18H601.7V451.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.56
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M473.31 451.14L473.34 451.89H472.77C472.77 452.02 472.76 453.24 472.76 453.24H469.89V451.93H469.36V451.14H473.33H473.31Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M469.42 446L469.4 445.25H469.97C469.97 445.12 469.98 443.9 469.98 443.9H472.86V445.21H473.39V446.01H469.42V446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M505.1 445.88L505.07 445.13H505.64C505.64 445 505.65 443.78 505.65 443.78H508.53V445.09H509.06V445.89H505.09L505.1 445.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M520.9 445.89L520.87 445.14H521.44C521.44 445.01 521.45 443.79 521.45 443.79H524.33V445.1H524.86V445.89H520.89H520.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M537.8 445.84L537.77 445.09H538.34C538.34 444.96 538.35 443.74 538.35 443.74H541.23V445.05H541.76V445.85H537.79L537.8 445.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M554.51 445.71L554.48 444.96H555.05C555.05 444.83 555.06 443.61 555.06 443.61H557.94V444.92H558.47V445.71H554.5H554.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M570.65 445.92L570.62 445.17H571.19C571.19 445.04 571.2 443.82 571.2 443.82H574.07V445.13H574.6V445.92H570.63H570.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M574.89 450.97L574.92 451.72H574.35C574.35 451.85 574.34 453.07 574.34 453.07H571.46V451.76H570.93V450.96H574.9L574.89 450.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.71
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M568.46 446.22V435.36L570.48 435.28L570.36 446.22H568.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.9
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M486.07 406.22C486.07 407.63 484.93 408.77 483.52 408.77C482.11 408.77 480.97 407.63 480.97 406.22C480.97 404.81 482.11 403.67 483.52 403.67C484.93 403.67 486.07 404.81 486.07 406.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M490.81 399.37C490.81 400.27 490.05 401 489.11 401C488.17 401 487.41 400.27 487.41 399.37C487.41 398.47 488.17 397.74 489.11 397.74C490.05 397.74 490.81 398.47 490.81 399.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M505.46 398.8C505.46 400.08 504.42 401.11 503.15 401.11C501.88 401.11 500.84 400.07 500.84 398.8C500.84 397.53 501.88 396.49 503.15 396.49C504.42 396.49 505.46 397.53 505.46 398.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.78,
    strokeLinecap: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M510.77 387.14L509.76 384.33L509.99 380.1L502.91 378.98L502.27 381.45L500.7 384.33L498.6 386.46L495.94 389.12L513.69 392.27L511.41 388.53L510.77 387.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M508.84 398.73C508.84 401.79 506.36 404.27 503.3 404.27C500.24 404.27 497.76 401.79 497.76 398.73C497.76 395.67 500.24 393.19 503.3 393.19C506.36 393.19 508.84 395.67 508.84 398.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M496.28 388.9C499.53 386.56 501.91 383.39 502.87 378.86L510.06 379.87C509.06 385.1 511.16 388.65 513.39 392.12",
    fill: "#131F2E"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M496.28 388.9C499.53 386.56 501.91 383.39 502.87 378.86L510.06 379.87C509.06 385.1 511.16 388.65 513.39 392.12",
    stroke: "#F7F9F9"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M511.09 398.88C511.09 403.18 507.6 406.67 503.3 406.67C499 406.67 495.51 403.18 495.51 398.88C495.51 394.58 499 391.09 503.3 391.09C507.6 391.09 511.09 394.58 511.09 398.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M518.17 395.53C518.17 396.26 517.58 396.86 516.86 396.86C516.14 396.86 515.55 396.26 515.55 395.53C515.55 394.8 516.14 394.2 516.86 394.2C517.58 394.2 518.17 394.79 518.17 395.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M544.57 405.77C544.57 408.71 542.19 411.09 539.25 411.09C536.31 411.09 533.93 408.71 533.93 405.77C533.93 402.83 536.31 400.45 539.25 400.45C542.19 400.45 544.57 402.83 544.57 405.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M534.68 405.17C534.68 405.87 534.11 406.44 533.41 406.44C532.71 406.44 532.14 405.87 532.14 405.17C532.14 404.47 532.71 403.9 533.41 403.9C534.11 403.9 534.68 404.47 534.68 405.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M550.31 405.47C550.31 411.43 545.41 416.26 539.37 416.26C533.33 416.26 528.43 411.43 528.43 405.47C528.43 399.51 533.33 394.68 539.37 394.68C545.41 394.68 550.31 399.51 550.31 405.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M518.5 388.8C521.44 389.31 523.31 391.62 523.85 394.97C524.06 396.29 524.76 397.72 526.7 397.87C527.6 397.95 531.49 398.13 531.49 398.13",
    fill: "#131F2E"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M518.5 388.8C521.44 389.31 523.31 391.62 523.85 394.97C524.06 396.29 524.76 397.72 526.7 397.87C527.6 397.95 531.49 398.13 531.49 398.13",
    stroke: "#F7F9F9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M508.62 416.22C514.69 416.03 515.36 407.16 522.1 407.49C527.94 407.15 529.66 415.47 537.38 416.18",
    fill: "#131F2E"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M508.62 416.22C514.69 416.03 515.36 407.16 522.1 407.49C527.94 407.15 529.66 415.47 537.38 416.18",
    stroke: "#F7F9F9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M490.53 382.36V385.73L489.22 385.84L488.66 386.51L488.58 389.17L491.69 390.03L494.31 390.14L494.23 386.58L492.88 385.64V382.76L490.52 382.35L490.53 382.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M494.99 381.63C494.99 382.43 493.89 383.08 492.53 383.08C491.17 383.08 490.07 382.43 490.07 381.63C490.07 380.83 491.17 380.18 492.53 380.18C493.89 380.18 494.99 380.83 494.99 381.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M459.34 397.75C459.34 399.04 458.79 400.08 458.1 400.09C457.41 400.09 456.85 399.05 456.85 397.77C456.85 396.47 457.4 395.42 458.09 395.42C458.78 395.42 459.34 396.46 459.34 397.74V397.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M460.62 403.9H458.02V407.82H460.62V403.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M465.2 388.38V390.07H468.06V389.12H469.17V388.3L465.21 388.38H465.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M468.6 392.23H466.98V394.12H468.6V392.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.88,
    strokeLinecap: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M260.15 463.11L264.35 459.22H279.78L279.63 476.6L273.34 464.32L270.64 464.17L270.19 474.51L268.69 476.31L260.15 463.13V463.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M278.49 462.65H420.43C420.43 462.65 420.48 462.67 420.48 462.7V477.42C420.48 477.42 420.46 477.47 420.43 477.47H278.49C278.49 477.47 278.44 477.45 278.44 477.42V462.7C278.44 462.7 278.47 462.65 278.49 462.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinecap: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M365.51 463.98L281.72 463.87L281.56 462.6",
    fill: "#131F2E"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M365.51 463.98L281.72 463.87L281.56 462.6",
    stroke: "#F7F9F9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M365.51 462.65V477.64V462.65Z",
    fill: "#131F2E"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M365.51 462.65V477.64",
    stroke: "#F7F9F9"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M339.3 460.47V434.97H351.7V460.59L339.3 460.46V460.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M357.24 460.25L357.19 462.72L278.29 462.95V460.25H357.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M293.37 426.64H306.18L320.53 460.34L293.1 460.28L293.37 426.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.27
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M295.98 458.83H293.28V460.72H295.98V458.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M306.04 457.66H319.71V460.04H306.09L306.04 457.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 458.6H303.66V460.49H306.36V458.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M303.21 456.04H296.42V459.37H303.21V456.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M302.27 453.48H297.59V455.73H302.27V453.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M343.25 435.04V456.53H351.64V434.91L343.25 435.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M343.4 458.83H340.7V460.72H343.4V458.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M353.78 458.6H351.08V460.49H353.78V458.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M350.63 456.04H343.84V459.37H350.63V456.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M349.69 453.48H345.01V455.73H349.69V453.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M295.95 433.21L296.1 410.95L322.61 406.04L322.48 433.39L295.95 433.2V433.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.27
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M293.34 424.74L317.56 424.42L317.69 427.09L293.28 426.64L293.34 424.73V424.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.27
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M342.8 437.17C342.8 448.07 333.96 456.91 323.06 456.91C312.16 456.91 303.32 448.07 303.32 437.17C303.32 426.27 312.16 417.43 323.06 417.43C333.96 417.43 342.8 426.27 342.8 437.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M339.56 437.14C339.56 446.23 332.19 453.61 323.09 453.61C313.99 453.61 306.62 446.24 306.62 437.14C306.62 428.04 313.99 420.67 323.09 420.67C332.19 420.67 339.56 428.04 339.56 437.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M324.43 424.96C324.43 425.75 323.79 426.39 323 426.39C322.21 426.39 321.57 425.75 321.57 424.96C321.57 424.17 322.21 423.53 323 423.53C323.79 423.53 324.43 424.17 324.43 424.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M324.43 449.38C324.43 450.17 323.79 450.81 323 450.81C322.21 450.81 321.57 450.17 321.57 449.38C321.57 448.59 322.21 447.95 323 447.95C323.79 447.95 324.43 448.59 324.43 449.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M312.22 437.17C312.22 437.96 311.58 438.6 310.79 438.6C310 438.6 309.36 437.96 309.36 437.17C309.36 436.38 310 435.74 310.79 435.74C311.58 435.74 312.22 436.38 312.22 437.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M336.82 437.17C336.82 437.96 336.18 438.6 335.39 438.6C334.6 438.6 333.96 437.96 333.96 437.17C333.96 436.38 334.6 435.74 335.39 435.74C336.18 435.74 336.82 436.38 336.82 437.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M299.93 455.55V466.16V455.55Z",
    fill: "#131F2E"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M299.93 455.55V466.16",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M347.35 455.55V466.16V455.55Z",
    fill: "#131F2E"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M347.35 455.55V466.16",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M272.12 450.41V436.1L269.2 438.65V451.08L272.12 450.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M271.69 468.66H269.15V472.32H266.61V425.45H269.31L269.1 465.49H271.75L271.7 468.67L271.69 468.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M266.71 438.47C266.66 438.89 269.73 438.31 269.73 438.31C269.73 438.31 272.43 436.56 272.85 434.55C272.92 433.56 273.74 434.26 273.06 431.58C273.17 431.1 271.68 430.57 271.68 430.57C271.68 430.57 271.47 432.32 269.67 434.81C269.67 434.81 267.92 436.5 265.59 436.93C265.59 436.93 265.17 438.15 266.7 438.47H266.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M266.5 450.55H271.69L271.64 452.88H266.66L266.5 450.55Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M277 457L290.56 456.87V459.86H277V457Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M266.62 455.68L268.95 455.58V460.56H266.62V455.69V455.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M269.16 455.68H273.4V460.24H269.06L269.17 455.68H269.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M273.5 455.65L276.99 456.92V460.31H273.23L273.5 455.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M110.89 265.42H105.65V320.7H110.89V265.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M98.01 322.34H76.74V326.09H98.01V322.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3 383.24C96.4 390.13 105.09 389.91 107.48 383.39L108.6 379.05",
    fill: "#131F2E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3 383.24C96.4 390.13 105.09 389.91 107.48 383.39L108.6 379.05",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8201 476.27H94.2301L94.3001 382.04L80.8201 381.89V476.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4101 476.42L91.2401 382.04H80.8301V476.34L91.4201 476.42H91.4101Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9001 378.82H76.8501V382.26H97.9001V378.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M113.44 325.34H62.96V379.42H113.44V325.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M111.2 328.78H65.21V375.97H111.2V328.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M77.79 367.64C77.79 370.98 75.21 373.69 72.02 373.69C68.83 373.69 66.25 370.98 66.25 367.64C66.25 364.3 68.83 361.59 72.02 361.59C75.21 361.59 77.79 364.3 77.79 367.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M89.77 367.67C89.77 371.03 87.19 373.74 84 373.74C80.81 373.74 78.23 371.02 78.23 367.67C78.23 364.32 80.81 361.59 84 361.59C87.19 361.59 89.77 364.31 89.77 367.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M101.76 367.62C101.76 370.95 99.18 373.65 95.99 373.65C92.8 373.65 90.22 370.95 90.22 367.62C90.22 364.29 92.8 361.59 95.99 361.59C99.18 361.59 101.76 364.29 101.76 367.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5599 367.58C75.5599 369.41 74.0799 370.9 72.2399 370.9C70.3999 370.9 68.9199 369.42 68.9199 367.58C68.9199 365.74 70.3999 364.26 72.2399 364.26C74.0799 364.26 75.5599 365.74 75.5599 367.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5499 367.58C87.5499 369.41 86.0699 370.9 84.2299 370.9C82.3899 370.9 80.9099 369.42 80.9099 367.58C80.9099 365.74 82.3899 364.26 84.2299 364.26C86.0699 364.26 87.5499 365.74 87.5499 367.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5299 367.58C99.5299 369.41 98.0499 370.9 96.2099 370.9C94.3699 370.9 92.8899 369.42 92.8899 367.58C92.8899 365.74 94.3699 364.26 96.2099 364.26C98.0499 364.26 99.5299 365.74 99.5299 367.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9 332.38H109.25C109.91 332.38 110.45 332.92 110.45 333.58V358.15C110.45 358.81 109.91 359.35 109.25 359.35H67.9C67.24 359.35 66.7 358.81 66.7 358.15V333.58C66.7 332.92 67.24 332.38 67.9 332.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 335.23H68.6499V357.1H108.8V335.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 320.39H112.39C113.05 320.39 113.59 320.93 113.59 321.59V323.99C113.59 324.65 113.05 325.19 112.39 325.19H104.9C104.24 325.19 103.7 324.65 103.7 323.99V321.59C103.7 320.93 104.24 320.39 104.9 320.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M106.4 258.08H110.9C112.22 258.08 113.3 259.15 113.3 260.48V263.63C113.3 264.95 112.23 266.03 110.9 266.03H106.4C105.08 266.03 104 264.96 104 263.63V260.48C104 259.16 105.07 258.08 106.4 258.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M103.73 262.35H76.1599",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M100.43 247.97V276.13",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M96.54 250.44V273.81",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6101 253.47V270.92",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M88.79 257.1V268.6",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1899 259.5V265.16",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M80.96 260.7V264.14",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirBalanced);
export default __webpack_public_path__ + "static/media/air-balanced.6bf743b1cafd60d003b24eaee4463adb.svg";
export { ForwardRef as ReactComponent };